















































import Vue from 'vue';
import { camelToKebabCase } from '@/utils';

export default Vue.extend({
  name: 'SelectNewsImageModal',
  data() {
    return {
      imageModel: {} as any,
      cropperConfig: {
        maxFileSizeInBytes: 1 * 1024 * 1024,
        zoomSpeedMultiplier: 4,
      },
      loader: {
        isImageUploading: false,
      },
      validationErrors: {
        invalidImageType: false,
        invalidImageSize: false,
      } as { [key: string]: boolean },
    };
  },
  mounted() {
    this.$root.$on('bv::modal::hide', () => this.resetValidation());
  },
  destroyed() {
    this.$root.$off('bv::modal::hide', () => this.resetValidation());
  },
  computed: {
    isImageInvalid(): boolean {
      return Object.values(this.validationErrors).some((e) => e);
    },
    isUploadDisabled(): boolean {
      return this.isImageInvalid || !this.imageModel.hasImage();
    },
    activeValidationError(): string {
      return Object.keys(this.validationErrors)[Object.values(this.validationErrors).findIndex((e) => e)];
    },
  },
  methods: {
    resetValidation() {
      for (const key in this.validationErrors) {
        if (this.validationErrors.hasOwnProperty(key)) {
          this.validationErrors[key] = false;
        }
      }
    },

    async upload() {
      this.$emit('newsImageSelected', this.imageModel.promisedBlob());
      this.$bvModal.hide('select-news-image-modal');
    },

    showSizeLimitErrorMessage() {
      this.validationErrors.invalidImageSize = true;
      this.imageModel.remove();
    },

    showInvalidTypeErrorMessage() {
      this.validationErrors.invalidImageType = true;
      this.imageModel.remove();
    },
    camelToKebabCase,
  },
});
